import classNames from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

type OpenModalButtonProps = {
  className?: string;
  onClick: () => void;
};

export const OpenModalButton: FC<OpenModalButtonProps> = ({ className, onClick }) => {
  const { formatMessage } = useIntl();
  return (
    <div className={classNames('d-flex flex-row-reverse', className)} data-e2e="raw-value-for-money">
      <button
        analytics-category="Regulation"
        analytics-event="Raw value for Money"
        analytics-on="click"
        className="btn btn-flat-primary btn-icon-end"
        data-e2e="raw-vfm-button"
        onClick={onClick}
        type="button"
      >
        {formatMessage({ id: 'raw-vfm-button-label' })}
        <i className="icon icon-md">launch</i>
      </button>
    </div>
  );
};
